import { isNot } from 'typescript-styled-is'
import styled from '../../../theme'

const PageTitle = styled.h1<IPageTitleProps>`
  font-size: ${({ size }) => (size ? 0.8 * size : 0.8)}em;
  font-weight: 600;
  padding: ${({ size }) => (size ? 1.5 * size : 1.5)}em
    ${({ size }) => (size ? 1.5 * size : 1.5)}em;
  margin: 0em;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;

  ${isNot('desktop')`
  	padding-bottom: ${({ size }) => (size ? size : 1)}em;
  `}
`

export default PageTitle

export interface IPageTitleProps {
  desktop?: boolean
  size?: number
}
